export default "__VITE_ASSET__B5w0gS1a__"